import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Turnos } from '../../../src/models/turnos/turnos.models';
import { UtilsProvider } from '../../providers/utils/utils';
import chroma from 'chroma-js';
import { ReservasProvider } from '../../providers/reservas/reservas';
import { ImpresoraBluetoothPage } from '../../pages/impresora-bluetooth/impresora-bluetooth';
import { ModalController } from 'ionic-angular';

@Component({
  selector: 'gestionproductos',
  templateUrl: 'gestionproductos.html',
  providers: [ReservasProvider]
})
export class GestionproductosComponent {

  @Input() nombreGrupoReserva
  @Input() listaProductos = []
  turno = 'Turno';
  turnos: Turnos;
  listaProductosSeleccionados = []
  valorTotalVenta = 0
  valorTotalProductos = 0
  valorTotalImpuestos = 0
  price = 0
  valorTotalDevolver = 0
  realizandoUnaVenta: boolean = false
  CheckPorcentajeServicio:boolean = false
  listaCentroDeCostosGestion = []
  listaTurno = []
  showSelect: boolean = false;
  @Output() cambioGrupoReserva = new EventEmitter<string>();
  @Output() listaCalendar = new EventEmitter<string>();
  @Input() filtroProductosReserva: string; // Asegúrate de tener esta línea
  constructor( public utilsMensajero:UtilsProvider,public reservasProvider: ReservasProvider,
    public modalControllers: ModalController,
  ) {

  }

  aclararColor(color: string): string {
    return chroma(color).brighten(1).hex(); // Ajusta el factor según necesites
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.listaProductos && changes.listaProductos.currentValue &&
        changes.listaProductos.currentValue.length > 0) {
      this.listaProductos = changes.listaProductos.currentValue.map(item => {
        const colorAclarado = this.aclararColor(item.color);
        const textColor = this.isColorLight(item.color) ? '#000000' : '#FFFFFF';
        return { ...item, colorAclarado, textColor };
      });
      this.nombreGrupoReserva = "";
      this.cambioGrupoReserva.emit("");
      return
    }

    if (changes.filtroProductosReserva !== undefined &&
      changes.filtroProductosReserva.currentValue !== undefined &&
      changes.filtroProductosReserva.currentValue !== "") {
      this.nombreGrupoReserva = changes.filtroProductosReserva.currentValue;
      this.cambioGrupoReserva.emit(this.nombreGrupoReserva);
    }

  }

    // Función para determinar si un color es claro u oscuro
  isColorLight(color: string): boolean {
    return chroma(color).luminance() > 0.5;
  }

  gestionarCambioFiltro(nuevoFiltroId: string) {
    this.nombreGrupoReserva = nuevoFiltroId;
  }

  cambioFiltro(nuevoFiltroId: string) {
    this.nombreGrupoReserva = nuevoFiltroId;
  }

  gestionarCambioFiltroProductos(values:any) {
    this.nombreGrupoReserva = values;
  }

  aumentarUnProductoSinExistencia(item, index) {
    this.utilsMensajero.mensajeMuestro('Advertencia','En desarrollo','Advertencia')
    return
  }

  aumentarUnProducto(item, index) {
    let nuevaCantidad = Number(item['cantidad']) + 1
    let insertUpdate: any
    nuevaCantidad = isNaN(nuevaCantidad) === true ? 1 : nuevaCantidad
    let existeProductoSelecionado = this.listaProductosSeleccionados.filter((values)=> values.productosId == item.productosId)
    nuevaCantidad = existeProductoSelecionado.length > 0 ? existeProductoSelecionado[0].cantidad + 1 : 1
    let agregoAlCarrito: boolean = false;
    let existeElProducto = item['Uuid'] !== undefined;

    if(!existeElProducto){
      agregoAlCarrito = true;
      nuevaCantidad = 1;
      insertUpdate = this.agregarAlCarritoProductoExistente(item)
    } else {
      if(this.listaProductosSeleccionados.length === 0) {
        if(this.turnos.turno !== 0 && this.turnos.turno !== null){
          agregoAlCarrito = true;
          this.agregarAlCarrito(item)
        } else {
          this.utilsMensajero.mensajeMuestro('Advertencia','Debe seleccionar una mesa para poder continuar','Advertencia')
          return
        }
      } else {
        let id = Number(item['productosId'])
        let existe = this.listaProductosSeleccionados.filter((item) => item.productosId == id)
        if(existe.length == 0) {
          if(this.turnos.turno !== 0 && this.turnos.turno !== null){
            agregoAlCarrito = true;
            this.agregarAlCarrito(item)
          } else {
          this.utilsMensajero.mensajeMuestro('Advertencia','Debe seleccionar una mesa para poder continuar','Advertencia')
          return
          }
        } else {
          agregoAlCarrito = true;
          nuevaCantidad = 1;
          insertUpdate = this.agregarAlCarritoProductoExistente(item)
        }
      }
    }


    let existe = this.devolverIndex(item)
    index = existe.length == 0 ? 0 : existe[0].index
    if(insertUpdate.insertUpdate) {
      this.listaProductosSeleccionados[index]['cantidad'] = Number(insertUpdate.nuevaCantidad)
    }

    this.listaProductosSeleccionados[index]['numeroPedido'] = this.turnos.numeroPedido
    this.listaProductosSeleccionados[index]['turno'] = this.turnos.turno
    if(!agregoAlCarrito) {
      this.calcularValorTotalVenta(item, index,true)
    }
    this.actualizarReal(item, index)
    if(this.CheckPorcentajeServicio){
      this.cambiarCheckPorcentaje()
    }
  }

  agregarAlCarritoProductoExistente(item): any {
    this.realizandoUnaVenta = true
    let nuevaCantidad: number = 1
    let insertUpdate: boolean = false
    let productosId = item['productosId']

    let tipoProducto = item['tipoProducto']

    let contarProductosConElMismoId = this.listaProductosSeleccionados.filter(item => item.productosId === productosId && item.tipoProducto === tipoProducto)
    if (contarProductosConElMismoId.length>0) {

      let existeElProducto = contarProductosConElMismoId.filter(item => item.productosId === productosId && item.tipoProducto === tipoProducto && item.agregado === 1)

      if(existeElProducto.length>0) {
        if(existeElProducto.length> 1 || (existeElProducto[0].comandasId !== undefined && existeElProducto[0].estadoGestion !== "1")) {
          this.listaProductosSeleccionados.forEach((elemento, indice) => {
            elemento["indice"] = indice;
          });
          let existeProductoUnificado: any = this.unificarProductosGestionados(existeElProducto)
          if(existeProductoUnificado.length === 1) {
            let centroDeCostosGestionId =  item['centroDeCostosGestionId']
            let existeGestion = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosGestionId === centroDeCostosGestionId)
            if(existeGestion.length> 0) {
              let existeGestionCambiarEstado = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosId === existeGestion[0].centroDeCostosId && (item.gestionar === "0" || item.gestionar === null || item.gestionar === undefined))
              if(existeGestionCambiarEstado.length>0){
                if(item.estadoGestion === "0") {
                  this.listaProductosSeleccionados[item.indice]['cantidad'] = Number(this.listaProductosSeleccionados[item.indice]['cantidad']) + 1
                  this.listaProductosSeleccionados[item.indice]['numeroPedido'] = this.turnos.numeroPedido
                  this.listaProductosSeleccionados[item.indice]['turno'] = this.turnos.turno
                  nuevaCantidad = this.listaProductosSeleccionados[item.indice]['cantidad']
                  insertUpdate = true
                } else {
                  let nuevoItem = {...item}
                  nuevoItem['color'] = existeGestionCambiarEstado[0].color
                  nuevoItem['estadoGestion'] = "0"
                  nuevoItem['Uuid'] = undefined
                  nuevoItem['comandasId'] = undefined
                  nuevoItem['update'] = false
                  nuevoItem['cantidad'] = 1
                  insertUpdate = false
                  this.listaProductosSeleccionados.push(nuevoItem)
                }

              } else {
                insertUpdate = false
                this.listaProductosSeleccionados.push(item)
              }
            } else {
              insertUpdate = false
              this.listaProductosSeleccionados.push(item)
            }
          } else {
            let existeElProductoSeleccionNoGestion = existeElProducto.filter(item => item.productosId === productosId && item.tipoProducto === tipoProducto && item.agregado === 1 && (item.estadoGestion === "0" || item.estadoGestion === null || item.estadoGestion === undefined))
            let index = existeElProductoSeleccionNoGestion[0].indice
            this.listaProductosSeleccionados[index]['cantidad'] = Number(this.listaProductosSeleccionados[index]['cantidad']) + 1
            this.listaProductosSeleccionados[index]['numeroPedido'] = this.turnos.numeroPedido
            this.listaProductosSeleccionados[index]['turno'] = this.turnos.turno
            nuevaCantidad = this.listaProductosSeleccionados[index]['cantidad']
            insertUpdate = true
          }

        } else {
          let centroDeCostosGestionId =  item['centroDeCostosGestionId']
          let existeGestion = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosGestionId === centroDeCostosGestionId)
          if(existeGestion.length> 0) {
            let existeGestionCambiarEstado = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosId === existeGestion[0].centroDeCostosId && (item.gestionar === "0" || item.gestionar === null || item.gestionar === undefined))
            if(existeGestionCambiarEstado.length>0){
              let nuevoItem = {...item}
              nuevoItem['color'] = existeGestionCambiarEstado[0].color
              nuevoItem['estadoGestion'] = "0"
              nuevoItem['Uuid'] = undefined
              nuevoItem['comandasId'] = undefined
              nuevoItem['update'] = false
              nuevoItem['cantidad'] = 1
              insertUpdate = false
              this.listaProductosSeleccionados.push(nuevoItem)
            } else {
              insertUpdate = false
              this.listaProductosSeleccionados.push(item)
            }
          } else {
            insertUpdate = false
            this.listaProductosSeleccionados.push(item)
          }
        }

      } else {
        let existeElProducto = contarProductosConElMismoId.filter(item => item.productosId === productosId && item.tipoProducto === tipoProducto)
        if(existeElProducto.length>0) {
          this.listaProductosSeleccionados.forEach((elemento, indice) => {
            elemento["indice"] = indice;
          });
          let existeElProductoSeleccionNoGestion = this.listaProductosSeleccionados.filter(item => item.productosId === productosId && item.tipoProducto === tipoProducto)
          let index = existeElProductoSeleccionNoGestion[0].indice
          this.listaProductosSeleccionados[index]['cantidad'] = Number(this.listaProductosSeleccionados[index]['cantidad']) + 1
          this.listaProductosSeleccionados[index]['numeroPedido'] = this.turnos.numeroPedido
          this.listaProductosSeleccionados[index]['turno'] = this.turnos.turno
          this.listaProductosSeleccionados[index]['estadoGestion'] ="0"
          nuevaCantidad = this.listaProductosSeleccionados[index]['cantidad']
          insertUpdate = true
        }  else {
          let centroDeCostosGestionId =  item['centroDeCostosGestionId']
          let existeGestion = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosGestionId === centroDeCostosGestionId)
          if(existeGestion.length> 0) {
            let existeGestionCambiarEstado = this.listaCentroDeCostosGestion.filter(item => item.centroDeCostosId === existeGestion[0].centroDeCostosId && (item.gestionar === "0" || item.gestionar === null || item.gestionar === undefined))
            if(existeGestionCambiarEstado.length>0){
              let nuevoItem = {...item}
              nuevoItem['color'] = existeGestionCambiarEstado[0].color
              nuevoItem['estadoGestion'] = "0"
              nuevoItem['Uuid'] = undefined
              nuevoItem['comandasId'] = undefined
              nuevoItem['update'] = false
              nuevoItem['cantidad'] = 1
              insertUpdate = false
              this.listaProductosSeleccionados.push(nuevoItem)
            } else {
              insertUpdate = false
              this.listaProductosSeleccionados.push(item)
            }
          } else {
            insertUpdate = false
            this.listaProductosSeleccionados.push(item)
          }
        }

      }
    } else {
      if(item['cantidad'] == undefined) {
        item['cantidad']
      }
      item['cantidad'] = 1
      insertUpdate = false
      this.listaProductosSeleccionados.push(item)
    }

    let valor = Number(item['valorVenta'])
    this.valorTotalVenta = this.valorTotalVenta + valor
    this.valorTotalProductos = this.valorTotalProductos + item['valorProducto']
    this.valorTotalImpuestos = this.valorTotalImpuestos + item['valorImpuesto']
    return {insertUpdate,nuevaCantidad}
  }

  agregarAlCarrito(item) {
    this.realizandoUnaVenta = true
    let productosId = item['productosId']

    let tipoProducto = item['tipoProducto']
    let contarProductosConElMismoId = this.listaProductosSeleccionados.filter(item => item.productosId === productosId && item.tipoProducto === tipoProducto)
    if (contarProductosConElMismoId.length > 0) {
      return
    }

    if(item['cantidad'] == undefined) {
      item['cantidad']
    }
    item['cantidad'] = 1
    this.listaProductosSeleccionados.push(item)

    let valor = Number(item['valorVenta'])
    this.valorTotalVenta = this.valorTotalVenta + valor
    this.valorTotalProductos = this.valorTotalProductos + item['valorProducto']
    this.valorTotalImpuestos = this.valorTotalImpuestos + item['valorImpuesto']
  }

  devolverIndex(item) {
    let existe = []
    for(let i =0; i < this.listaProductosSeleccionados.length;i++) {
      if(item['productosId'] == this.listaProductosSeleccionados[i].productosId) {
        existe.push(this.listaProductosSeleccionados[i])
        existe[0].index = i
      }
    }
    return existe
  }

  calcularValorTotalVenta(item: any, indexActual: any, queHago: boolean) {
    if(this.listaProductosSeleccionados.length> 0) {
      let valorTotalVentaJson: any = this.listaProductosSeleccionados.map((items: any, index: number) => {
        return {
            valorTotalVenta: Number(items.valorVenta) * Number(items.cantidad),
            valorGestionado: items.index === indexActual ? Number(items.valorVenta) : 0
            }
      })
    let valorTotalVenta = Object.keys(valorTotalVentaJson).map(function(key) {
        return valorTotalVentaJson[key].valorTotalVenta;
    });
    let valorTotalVentaReduce = valorTotalVenta.reduce((previous, current) => previous + current, 0);
    if(queHago) {
      this.valorTotalVenta = valorTotalVentaReduce
    }
    }
  }

  actualizarReal(item: any, index: any) {
    let id = Number(item['productosId'])
    let tipoProducto = item['tipoProducto']
    for (let i = 0; i < this.listaProductos.length; i++) {
      if (this.listaProductos[i].productosId == id && this.listaProductos[i].tipoProducto == tipoProducto) {
        this.listaProductosSeleccionados[index]['valorImpuesto'] = this.listaProductos[i]['valorImpuesto'] == undefined ? 0 : this.listaProductos[i]['valorImpuesto']
        this.listaProductosSeleccionados[index]['valorProducto'] = this.listaProductos[i]['valorProducto'] == undefined ? 0 : this.listaProductos[i]['valorProducto']
        this.listaProductosSeleccionados[index]['queHago'] = true
        i = this.listaProductos.length + 1
      }
    }
  }

  cambiarCheckPorcentaje(){



    let cantidad = this.listaProductosSeleccionados.length
    let valorProducto = 0
    let valorVenta = 0
    let valorImpuesto = 0
    this.listaProductosSeleccionados.forEach((data,item)=>{

      valorProducto+= data.valorVenta * data.cantidad
      valorVenta+= data.valorVenta
      valorImpuesto+= data.valorImpuesto * data.cantidad
      if(cantidad === item + 1){

        let porcentaje = valorProducto * 10 / 100
        let valorTotalServicio = porcentaje
        this.valorTotalVenta = valorProducto + valorImpuesto + valorTotalServicio
      }

    })

}

unificarProductosGestionados(listaUnificar: any) {
  const groupedProducts = listaUnificar.reduce((acc, curr) => {
    const key = `${curr.productosId}-${curr.tipoProducto}-${curr.estadoGestion}`;
    if (!acc[key]) {
        acc[key] = { ...curr, cantidad: curr.cantidad };
    } else {
        acc[key].cantidad += curr.cantidad;
    }
    return acc;
    }, {});
  }

  gestionarUnProducto(item:any) {
    let id = Number(item.productosElaboradosId) > 0 &&
    Number(item.productosElaboradosId) === Number(item.mesasId)
    ? Number(item.mesasId) : Number(item.productosElaboradosId)

    let tipo = Number(item.productosElaboradosId) > 0 &&
    Number(item.productosElaboradosId) === Number(item.mesasId)
    ? "M" : "P"
    let producto = item
    this.cargarSeguimientosReserva(item.companiasId,id,tipo, producto, item.turno)
  }

  async cargarSeguimientosReserva(companiasId: any,id: any = null, tipo: any = '', producto: any, turno : any = 0) {
    this.reservasProvider.buscarSeguimientoReservas(companiasId,id, tipo, turno).subscribe((item: any)=> {
      let res = JSON.parse(item['_body']).data
      let data = res[0]
      data.push(producto)
      this.listaCalendar.emit(data)
    })

  }

  calcularValorLiquidarReservas(item: any) {
    this.showSelect = true;
    let companiasId = item.companiasId
    let turno = item.turno
    if(turno !== 0) {
      this.reservasProvider.calcularValorLiquidarReservas(companiasId,turno).subscribe((item: any)=> {
        let res = JSON.parse(item['_body']).data
        this.listaTurno = res[0]
      })
  }
  }

  actualizarValor(event:any) {
    this.listaTurno = []
    this.showSelect = false;
  }

  toggleSelectClose() {
    this.showSelect = false;
    this.listaTurno = []
  }

  imprimirData(data:any) {
    this.imprimirGestion(data)
  }

  imprimirGestion(data:any) {
    let modal = this.modalControllers.create(ImpresoraBluetoothPage, { data: data }, {
      cssClass: 'fullscreen-modal',
      enableBackdropDismiss: true
    }
    )
  modal.present();

  modal.onDidDismiss(data => {
    if (data) {
      //this.cantidadafnprueba.nativeElement.focus();
    }
  })
  }
}



// WEBPACK FOOTER //
// ./src/components/gestionproductos/gestionproductos.ts